import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable }     from '../../../node_modules/rxjs/Observable';

import { SERVER_URL } from './server-url';
import { NotificationAlert } from '../entities/notification-alert';

import { NotificationType } from '../entities/notification-type';
import { NotificationConfig } from '../entities/notification-config';

import { Tracker } from '../entities/tracker';
import { Driver } from '../entities/driver';
import { Delivery } from '../entities/delivery';

@Injectable()   
export class NotificationService {
    private notificationUrl = SERVER_URL + '/api/notifications';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public notificationConfig:NotificationConfig;
    public notifications:Array<NotificationAlert>;
    public notificationsOutOfRoute:Array<NotificationAlert>;
    public allNotifications:Array<NotificationAlert>;

    public isSoundActive:boolean = false;
    
    //Variavel de controle quando houver nova notificação (para emitir alerta sonoro)
    public newNotificationsOutOfRoute:Array<NotificationAlert> = [];


    constructor (private http: Http) {}
    
    getAllNotifications(tokenLogged:string): Observable<NotificationAlert[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.notificationUrl + '/all', {headers: headers})
                    .map(this.extractAllNotificationsFromJSON)
                    .catch(this.handleError);
    }

    getNotificationsActive(tokenLogged:string): Observable<NotificationAlert[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.notificationUrl, {headers: headers})
                    .map(this.extractNotificationsActiveFromJSON)
                    .catch(this.handleError);
    }

    getNotificationsActiveByType(type:NotificationType, tokenLogged:string): Observable<NotificationAlert[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.notificationUrl + '/type/' + type.id, {headers: headers})
                    .map(this.extractNotificationsActiveByTypeFromJSON)
                    .catch(this.handleError);
    }

    getNotificationConfig(tokenLogged:string): Observable<NotificationConfig> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.notificationUrl + '/config', {headers: headers})
                    .map(this.extractNotificationConfigFromJSON)
                    .catch(this.handleError);
    }

    deactivateNotification(tokenLogged:string, notification:NotificationAlert) {
            let headers = new Headers();
            headers.append('Authorization', 'JWT ' + tokenLogged);
            //console.log('chamando o serviço da services');
            return this.http.post(this.notificationUrl + '/deactivate', notification, {headers: headers})
                        .map(this.deleteCompanyExtractFromJSON)
                        .catch(this.handleError);
            
    }

    deactivateAllNotification(tokenLogged:string) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.notificationUrl + '/deactivate/all', null , {headers: headers})
                    .map(this.deleteCompanyExtractFromJSON)
                    .catch(this.handleError);        
        
    }

    saveNotificationConfig(notificationConfig:NotificationConfig, tokenLogged:string) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.notificationUrl + '/config', notificationConfig, {headers: headers})
                    .map(this.saveNotificationConfigResult)
                    .catch(this.handleError);        
    }

    saveNotificationConfigResult() {

    }

    private deleteCompanyExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    private extractAllNotificationsFromJSON(res: Response | any) {
        let body = res.json();
        var notificationList:NotificationAlert[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var notification:NotificationAlert = new NotificationAlert(
                entry.id,
                new Tracker(entry.tracker_id, null, null, null, null, null, null), 
                new Driver(entry.driver_id, null, null, null, null, null, null, null, null, null,null,null,null,null,null,null, null, null, null, null),
                new Delivery(entry.delivery_id, null, null,null,null,null,null,null,null,null,null,null,null,null,entry.id_external),
                new NotificationType(entry.type_id, entry.type_name, entry.type_desc, entry.type_color),
                new Date(entry.dt_active), new Date(entry.dt_inactive), entry.is_active, entry.data
            );
            
            notificationList.push(notification);
        }
        
        return notificationList;
    }
    
    private extractNotificationsActiveFromJSON(res: Response | any) {
        let body = res.json();
        var notificationList:NotificationAlert[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var notification:NotificationAlert = new NotificationAlert(
                entry.id,
                new Tracker(entry.tracker_id, null, null, null, null, null, null), 
                new Driver(entry.driver_id, null, null, null, null, null, null, null, null, null,null,null,null,null,null,null, null, null, null, null),
                new Delivery(entry.delivery_id, null,null,null,null,null,null,null,null,null,null,null,null,null,entry.id_external),
                new NotificationType(entry.type_id, entry.type_name, entry.type_desc, entry.type_color),
                new Date(entry.dt_active), new Date(entry.dt_inactive), true, entry.data
            );
            
            notificationList.push(notification);
        }
        
        return notificationList;
    }

    private extractNotificationsActiveByTypeFromJSON(res: Response | any) {
        let body = res.json();
        var notificationList:NotificationAlert[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var notification:NotificationAlert = new NotificationAlert(
                entry.id,
                new Tracker(entry.tracker_id, null, null, null, null, null, null), 
                new Driver(entry.driver_id, null, null, null, null, null, null, null, null, null,null,null,null,null,null,null, null, null, null, null),
                new Delivery(entry.delivery_id, null,null,null,null,null,null,null,null,null,null,null,null,null, entry.id_external),
                new NotificationType(entry.type_id, entry.type_name, entry.type_desc, entry.type_color),
                new Date(entry.dt_active), new Date(entry.dt_inactive), true, entry.data
            );
            
            notificationList.push(notification);
        }
        
        return notificationList;
    }


    private extractNotificationConfigFromJSON(res: Response | any) {
        let body = res.json();

        var notificationConfig: NotificationConfig = new NotificationConfig(
            body.email,
            body.panicIsSystem,
            body.panicIsEmail,
            body.stoppedOnIsSystem,
            body.stoppedOnIsEmail,
            body.stoppedOnConfig,
            body.stoppedOffIsSystem,
            body.stoppedOffIsEmail,
            body.stoppedOffConfig,
            body.noSignalIsSystem,
            body.noSignalIsEmail,
            body.noSignalConfig,
            body.cnhOutdatedIsSystem,
            body.cnhOutdatedIsEmail,
            body.cnhOutdatedConfig,
            body.maxVelocityIsSystem,
            body.maxVelocityIsEmail,
            body.outOfRouteIsSystem,
            body.outOfRouteIsEmail
        );

        return notificationConfig;
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            
            //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            errMsg = body.detail || 'Ocorreu um erro no servidor.';
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/notification.service.ts